var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvalid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "21px",
    viewBox: "0 0 25 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/invalid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/invalid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/InValid",
    transform: "translate(5.000000, 3.000000)",
    fill: "#B7844D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,15 C11.64195,15 15,11.64195 15,7.5 C15,3.35805 11.64195,0 7.5,0 C3.35805,0 0,3.35805 0,7.5 C0,11.64195 3.35805,15 7.5,15 Z M7.5,13.63653 C10.8891,13.63653 13.6365,10.88913 13.6365,7.50003 C13.6365,4.11093 10.8891,1.36353 7.5,1.36353 C4.1109,1.36353 1.3635,4.11093 1.3635,7.50003 C1.3635,10.88913 4.1109,13.63653 7.5,13.63653 Z M6.817965,4.09098 L8.182035,4.09098 L8.182035,8.86338 L6.817965,8.86338 L6.817965,4.09098 Z M6.817965,9.54543 L8.182035,9.54543 L8.182035,10.9089 L6.817965,10.9089 L6.817965,9.54543 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalid);
export default __webpack_public_path__ + "static/media/invalid.c8bad927742857929f298dc655934d4f.svg";
export { ForwardRef as ReactComponent };